import { PiCheckCircleFill, TbCircleDashedCheck, FiAlertCircle, IoRefresh } from '@/components/react-icons/main';
import { TbCircleDashedMinus } from 'react-icons/tb';
import Spinner from '@/components/Spinner';

const panelIconTabsMap = {
  valid: PiCheckCircleFill,
  'partial-success': TbCircleDashedMinus,
  pending: TbCircleDashedCheck,
  invalid: FiAlertCircle,
  redeploy: IoRefresh,
  loading: Spinner
};

export default panelIconTabsMap;
